import React, { useState, useEffect } from 'react';
import { handleMissing, getInfo } from '../../utils/api';
import { toast } from 'sonner';
import { useT } from '../../i18n';

const HandleMissingOperation = ({ onSuccess, onCancel }) => {
  const t = useT();
  const [strategy, setStrategy] = useState('drop_rows');
  const [fillValue, setFillValue] = useState('');
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadColumns = async () => {
      try {
        const result = await getInfo();
        setColumns(result.info.column_names || []);
      } catch (error) {
        toast.error(t('form.loadColumnsFailed'));
      }
    };
    loadColumns();
  }, []);

  const toggleColumn = (col) => {
    if (selectedColumns.includes(col)) {
      setSelectedColumns(selectedColumns.filter(c => c !== col));
    } else {
      setSelectedColumns([...selectedColumns, col]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const config = {
        strategy,
        columns: selectedColumns.length > 0 ? selectedColumns : null,
        fill_value: strategy === 'fill_value' ? fillValue : null
      };
      const result = await handleMissing(config);
      onSuccess(result);
    } catch (error) {
      toast.error(error.response?.data?.detail || t('missing.failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="label mb-2">{t('missing.strategy')}</label>
        <select value={strategy} onChange={(e) => setStrategy(e.target.value)} className="select">
          <option value="drop_rows">{t('missing.dropRows')}</option>
          <option value="fill_value">{t('missing.fillValue')}</option>
          <option value="fill_mean">{t('missing.fillMean')}</option>
          <option value="fill_median">{t('missing.fillMedian')}</option>
          <option value="fill_mode">{t('missing.fillMode')}</option>
        </select>
      </div>

      {strategy === 'fill_value' && (
        <div>
          <label className="label mb-1">{t('missing.valueLabel')}</label>
          <input
            type="text"
            value={fillValue}
            onChange={(e) => setFillValue(e.target.value)}
            className="input"
            placeholder={t('missing.valuePlaceholder')}
            required
          />
        </div>
      )}

      <div>
        <label className="label mb-2">{t('missing.applyTo')}</label>
        <div className="card p-4 max-h-48 overflow-y-auto space-y-2">
          {columns.map(col => (
            <label key={col} className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={selectedColumns.includes(col)}
                onChange={() => toggleColumn(col)}
                className="h-4 w-4"
              />
              <span className="text-sm">{col}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="flex gap-2 pt-4 border-t">
        <button type="submit" disabled={loading} className="btn-primary flex-1" data-testid="apply-handle-missing">
          {loading ? t('form.applying') : t('missing.apply')}
        </button>
        <button type="button" onClick={onCancel} className="btn-secondary">
          {t('form.cancel')}
        </button>
      </div>
    </form>
  );
};

export default HandleMissingOperation;